import type { IdentityCard, UserOverview } from '@wizbii/utils/models';

import { createAction, props } from '@ngrx/store';

export const initSessionSuccess = createAction(
  '[Session] init',
  props<{ userOverview: UserOverview; identityCard: IdentityCard }>()
);

export const updateIdentityCard = createAction('[Session] UpdateIdentityCard', props<{ identityCard: IdentityCard }>());
export const updateIdentityCardSuccess = createAction(
  '[Session] UpdateIdentityCard Success',
  props<{ identityCard: IdentityCard }>()
);
